import React from "react";
import "./Faq.css";

/**
 * The answers here must stay in sync with the FAQPage JSON-LD in
 * public/index.html — Google only shows FAQ rich results when the same
 * question and answer are visible on the page.
 */
const faqs = [
  {
    q: "Who is Aman Jaiswal?",
    a: (
      <>
        Aman Jaiswal is a <strong>frontend developer</strong> from Indore,
        Madhya Pradesh, India. He builds web applications with Angular, React
        and TypeScript, and currently works as a Senior Frontend Developer at
        Flair IT Solution Pvt. Ltd., after two and a half years as a frontend
        developer at Abacus Consultancy Services Pvt. Ltd.
      </>
    ),
  },
  {
    q: "What technologies does Aman Jaiswal work with?",
    a: (
      <>
        As an <strong>Angular and React developer</strong>, Aman Jaiswal works
        with Angular, React, TypeScript, JavaScript, HTML5, CSS3, RxJS and
        Angular Material on the frontend, and Node.js, Express and MySQL on the
        backend. He has also shipped real-time features using Socket.IO and
        WebRTC.
      </>
    ),
  },
  {
    q: "Is Aman Jaiswal available for frontend developer roles or freelance work?",
    a: (
      <>
        Yes. Aman Jaiswal takes on frontend developer work built around Angular,
        React and TypeScript, including full-time roles and freelance projects.
        You can reach him at{" "}
        <a href="mailto:aj27757@gmail.com" className="link">
          aj27757@gmail.com
        </a>{" "}
        or +91 7974999575.
      </>
    ),
  },
  {
    q: "Where is Aman Jaiswal, the Angular developer, based?",
    a: (
      <>
        Aman Jaiswal is based in Indore, Madhya Pradesh, India, and works with
        teams and clients remotely as an Angular and React developer.
      </>
    ),
  },
];

export const Faq = () => {
  return (
    <div className="section" data-aos="fade-right">
      <h2 className="section__title" id="faq-heading">
        Frequently Asked <span className="different">Questions</span>
      </h2>
      <div className="faq__list">
        {faqs.map(({ q, a }, idx) => (
          <details className="faq__item" key={q} open={idx === 0}>
            <summary className="faq__question">
              <h3>{q}</h3>
            </summary>
            <p className="faq__answer">{a}</p>
          </details>
        ))}
      </div>
    </div>
  );
};
